export default __webpack_public_path__ + "static/BayAreaCoupon-48603659c8407b11e346311047c1454c.png";